import React from 'react';
import withAppProps from 'src/utils/withHistory';
import { RouteName } from './config';
const MarketplacePage = /*#__PURE__*/React.lazy(() => import('../Pages/MarketplaceV2'));
const ItemDetailPage = /*#__PURE__*/React.lazy(() => import('../Pages/ItemDetailV2'));
const ConnectWalletPage = /*#__PURE__*/React.lazy(() => import('@profile/src/RemoteConnectWalletApp'));
const ProfilePage = /*#__PURE__*/React.lazy(() => import('@profile/src/RemoteProfileApp'));
const StakingPage = /*#__PURE__*/React.lazy(() => import('../Pages/Staking'));
const CosmeticDetailPage = /*#__PURE__*/React.lazy(() => import('../Pages/CosmeticDetail'));
const VestingSafePage = /*#__PURE__*/React.lazy(() => import('@vestingSafe/src/RemoteApp'));
const ProjectDetailPage = /*#__PURE__*/React.lazy(() => import('../Pages/ProjectDetailPage'));
const ProjectConfirmationPage = /*#__PURE__*/React.lazy(() => import('../Pages/ProjectConfirmationPage'));
const HomePage = /*#__PURE__*/React.lazy(() => import('../Pages/HomePage'));
const NotFoundPage = /*#__PURE__*/React.lazy(() => import('../Pages/NotFoundPage'));
const routes = [{
  key: 'home',
  exact: true,
  path: [RouteName.HomeDashboard, RouteName.Dashboard],
  component: HomePage
}, {
  key: 'profile',
  path: RouteName.Profile,
  component: withAppProps(ProfilePage)
}, {
  key: 'itemDetail',
  exact: true,
  path: `${RouteName.HeroDetail}/:id`,
  component: ItemDetailPage
}, {
  key: 'connectWallet',
  path: RouteName.Login,
  component: withAppProps(ConnectWalletPage)
}, {
  key: 'marketplace',
  exact: true,
  path: RouteName.MarketPlace,
  component: MarketplacePage
}, {
  key: 'staking',
  exact: true,
  path: [RouteName.Staking, RouteName.YourStaking],
  component: StakingPage
}, {
  key: 'cosmeticDetail',
  exact: true,
  path: `${RouteName.CosmeticDetail}/:id`,
  component: CosmeticDetailPage
}, {
  key: 'projectDetail',
  exact: true,
  path: `${RouteName.ProjectDetail}/:id`,
  component: ProjectDetailPage
}, {
  key: 'buyProject',
  exact: true,
  path: `${RouteName.ProjectDetail}/:id/buy`,
  component: ProjectConfirmationPage
}, {
  key: 'vestingSafe',
  exact: true,
  path: RouteName.VestingSafe,
  component: withAppProps(VestingSafePage)
}, {
  key: 'allRoute',
  exact: false,
  path: RouteName.AllRoute,
  component: NotFoundPage
}];
export const preloadRoutes = async () => {
  // remove or change the order of tabs to change priority of the tabs
  const tabsPriority = [() => import('src/Pages/HomePage'), () => import('src/Pages/MarketplaceV2'), () => import('src/Pages/ItemDetailV2'), () => import('@profile/src/RemoteProfileApp'), () => import('@profile/src/RemoteConnectWalletApp'), () => import('src/Pages/CosmeticDetail'), () => import('src/Pages/Staking'), () => import('src/Pages/NotFoundPage'), () => import('src/Pages/ProjectDetailPage'), () => import('src/Pages/ProjectConfirmationPage'), () => import('@vestingSafe/src/RemoteApp')];

  for (const preloadTab of tabsPriority) {
    await preloadTab(); // preload sequentially to prevent the client from being flushed from loading js files
  }
};
export default routes;